<template>
  <div class="blog__latest">

    <div class="container">
        <div class="row">
            <div class="pb-5 pb-sm-0 col-md-5 col-lg-4">
                <h3 class="title">
                    Рубрики
                </h3>
                <div class="blog__latest-categories d-flex flex-wrap">
                    
                    <template v-if="loadingCategories">
                        <loader />
                    </template>
                    <template v-else>
                        <template v-if="!categories.length">
                            <h3 class="d-flex justify-content-center align-items-center">
                                Рубрик нет
                            </h3>
                        </template>
                        <template v-else>
                            <category-item v-for="category in categories" :category="category" :key="category.slug" />
                        </template>
                    </template>

                </div>
            </div>
            <div class="pt-5 pt-sm-0 col-md-7 col-lg-8 mobile-gray">
                <h3 class="title mt-md-0 mt-3">
                    Последние статьи
                </h3>
                <template v-if="loadingArticles">
                    <loader />
                </template>
                <template v-else>
                <div class="blog__latest-articles">

                    <template v-if="!articles.length">
                        <h3 class="d-flex justify-content-center align-items-center">
                        Статей нет
                        </h3>
                    </template>
                    <template v-else>

                        <swiper :options="$options.sliderOptions">
                            
                            <swiper-slide v-for="article in articles" :key="article.key">
                                <latest-article :article="article" />
                            </swiper-slide>

                        </swiper>

                        <slider-pagination 
                            :idPrev="'latest-prev'" :idNext="'latest-next'"
                            :navigationBtn="$options.navigationBtn"
                        />

                    </template>

                </div>

                </template>

            </div>
        </div>
    </div>

  </div>
</template>

<script>

import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import SliderPagination from './SliderPagination.vue'
import LatestArticle from './LatestArticle.vue'
import Loader from '../LoaderBalls.vue'
import CategoryItem from './LatestCategoryItem.vue'
import { getPostsPreviews } from './api'
import { eventHub } from './eventHub'


export default {
    name: "BlogLatest",
    components: { Swiper, SwiperSlide, LatestArticle, SliderPagination, Loader, CategoryItem },

    data(){
        return{
            loadingArticles: false,
            loadingCategories: false,
            articles: [],
            categories: []
        }
    },

    mounted(){
        this.fetchPostPreviews()

        eventHub.$on(
            'update:postLiked', 
            this.handleUpdatePostLike
        );

    },

    navigationBtn: {
      href: '#',
      text: 'Смотреть все'
    },
    sliderOptions: {
        navigation: {
            nextEl: '#latest-next',
            prevEl: '#latest-prev',
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
                slidesPerColumn: 1,
            },
            768: {
                slidesPerView: 1,
                slidesPerColumn: 2,
            },
            992: {
                slidesPerView: 1,
                slidesPerColumn: 3,
            }
        }
    },

    methods:{
        handleUpdatePostLike( target ){
            this.articles = this.articles.map(
                it => {
                    if( it.id === target.post_id ) it.follow = target.follow

                    return it
                }
            )
        },
        async fetchPostPreviews(){
            this.loadingCategories = true 
            this.loadingArticles = true
            try{

                let { data: { categories = [], posts = [] } , success } = await getPostsPreviews()

                if( success ) {
                    this.categories = categories
                    this.articles = posts
                    this.loadingCategories = false
                    this.loadingArticles = false
                }

            } catch( e ){
                this.loadingCategories = false
                this.loadingArticles = false
            }

        },

    }

}
</script>

<style>

</style>